import React from 'react';
import classNames from 'classnames';
import css from './MainFiltersForm.css';

const CategoryDropdownSection = ({
  title,
  items = [],
  focusedIndex = -1,
  startIndex = 0,
  getDisplayedCategoryData,
  onSelectItem,
  searchQuery = '',
  keyPrefix = 'sec',
  clearButton = <></>,
}) => {
  if (!items || items.length === 0) return null;

  return (
    <div className={css.sectionGroup}>
      <div className={css.dropdownHeaderContainer}>
        {title && <p className={css.dropdownHeader}>{title}</p>}
        {clearButton}
      </div>

      {items.map((item, index) => {
        const globalIndex = startIndex + index;
        const isFocused = globalIndex === focusedIndex;

        const {
          labelText,
          displayKeyword,
          exact,
          labelObj,
          isSuggestion,
          keyword,
        } = getDisplayedCategoryData(item);

        return (
          <div
            key={`${keyPrefix}-${index}`}
            className={classNames(css.dropItem, { [css.focusedItem]: isFocused })}
            onClick={() => onSelectItem(item)}
          >
            <div className={css.itemText}>
              {isSuggestion ? (
                <>
                  <span
                    className={classNames(
                      css.itemLabel,
                      exact ? css.primaryCategory : css.keywordMatch
                    )}
                  >
                    {exact ? labelText : keyword.text}
                  </span>
                  {!exact && <span className={css.itemSubLabel}>{labelText}</span>}
                </>
              ) : (
                <>
                  <span className={classNames(css.itemLabel, { [css.textBold]: exact })}>
                    {displayKeyword}
                  </span>
                  {labelObj && !exact && <span className={css.itemSubLabel}>{labelText}</span>}
                </>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CategoryDropdownSection;
